import { Component, DestroyRef, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { deactivateComponentService } from '@shared/services/desactivate.service';
import { ErrorService } from '@shared/services/error.service';
import { InstanceIdService } from '@shared/services/instance-id.service';
import { SubscriptionManager } from '@shared/services/subscription-manager.service';
import { UtilisService } from '../../services/utilis.service';

@Component({
  selector: 'app-buttons-floating-component',
  templateUrl: './buttons-floating-component.component.html',
  styleUrls: ['./buttons-floating-component.component.scss'],
  standalone: false,
})
export class ButtonsFloatingComponent implements OnInit, OnDestroy {
  private instanceId: string;

  @Input() public buttonsConfiguration: IButton[] = defaultButtonsConfiguration;

  @Input() public disabled: boolean = false;

  @Input() public isSpinning: boolean = false;

  @Output() public onClick: EventEmitter<string> = new EventEmitter<string>();

  public isSideNavReduced: boolean = false;

  constructor(
    private utilisService: UtilisService,
    private errorService: ErrorService,
    private destroyRef: DestroyRef,
    private subscriptionManager: SubscriptionManager,
    private instanceIdService: InstanceIdService,
    private deactivateService: deactivateComponentService
  ) {
    this.instanceId = this.instanceIdService.generateId();
    this.subscriptionManager.registerComponent(this.instanceId, this.destroyRef);
    this.listenToSideNavSize();
  }

  ngOnInit() {
    this.deactivateService.hasUnsavedChanges.next(true);
  }

  ngOnDestroy() {
    this.deactivateService.hasUnsavedChanges.next(false);
  }

  listenToSideNavSize(): void {
    this.subscriptionManager
      .createRequest(this.utilisService.isSideNavReduced, 'isSideNavReduced', this.instanceId)
      .subscribe({
        next: (value: any) => {
          this.isSideNavReduced = value;
        },

        error: (error: any) => {
          this.errorService.handleError(error);
        },
      });
  }

  onClickHandler(onClickEventName: string): void {
    this.onClick.next(onClickEventName);
  }
}

interface IButton {
  text?: string;
  type?: string;
  color?: string;
  icon?: string;
  iconPosition?: string;
  iconType?: string;
  isSpinner?: boolean;
  onClickEventName?: string;
}

const defaultButtonsConfiguration: IButton[] = [
  {
    text: 'Annuler les modifications',
    type: 'text',
    color: 'primary',
    isSpinner: false,
    onClickEventName: 'discard',
  },
  {
    text: 'Sauvegarder les modifications',
    type: 'primary',
    color: 'primary',
    icon: 'save',
    iconPosition: 'left-icon',
    iconType: 'mat-icon',
    isSpinner: true,
    onClickEventName: 'save',
  },
];
